(() => {
  function init(root = document) {
    root.querySelectorAll('[data-collection]').forEach(section => {
      if (section.dataset.enhanced) return;
      section.dataset.enhanced = 'true';
      const sort = section.querySelector('[data-collection-sort]');
      sort.querySelector('select').addEventListener('change', () => sort.requestSubmit());
      const filterForm = section.querySelector('[data-filter-form]');
      filterForm?.addEventListener('change', event => {
        if (event.target.matches('input[type="checkbox"], input[type="number"]')) filterForm.requestSubmit();
      });
      const opener = section.querySelector('[data-filter-open]');
      const panel = section.querySelector('.main-collection__filters');
      const backdrop = section.querySelector('.main-collection__backdrop');
      const mobile = window.matchMedia('(max-width:999px)');
      let previousOverflow;
      function close() {
        const wasOpen = panel.classList.contains('is-open');
        panel.classList.remove('is-open');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        backdrop.hidden = true;
        opener?.setAttribute('aria-expanded', 'false');
        if (wasOpen) {
          document.body.style.overflow = previousOverflow;
          opener?.focus();
        }
        panel.setAttribute('aria-hidden', String(mobile.matches));
        panel.inert = mobile.matches;
      }
      opener?.addEventListener('click', () => {
        if (!mobile.matches) return;
        previousOverflow = document.body.style.overflow;
        panel.inert = false;
        panel.classList.add('is-open');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-hidden', 'false');
        opener.setAttribute('aria-expanded', 'true');
        backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
        panel.querySelector('[data-filter-close]').focus();
      });
      section.querySelectorAll('[data-filter-close]').forEach(button => button.addEventListener('click', close));
      panel.addEventListener('keydown', event => {
        if (!panel.classList.contains('is-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const controls = [...panel.querySelectorAll('button, a, input, summary, select')].filter(el => !el.disabled && el.getClientRects().length);
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      mobile.addEventListener('change', close);
      close();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
